module.exports = __webpack_public_path__ + "img/nk-logo.56fd6d61.png";